<template>
  <div class="vue-tempalte">
    <v-app
      :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }"
      :dark-theme="true"
      id="inspire"
    >
      <v-container>
        <v-layout wrap>
          <v-flex sm12 md6 offset-md3>
            <v-card elevation="4" light tag="section">
              <v-card-title>
                <v-layout align-center justify-space-between>
                  <h3 class="headline">
                    {{ "BICOM TASK" }}
                  </h3>
                </v-layout>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <p>Sign in with your username and password:</p>
                <v-form>
                  <v-text-field
                    outline
                    label="Username"
                    type="text"
                    v-model="username"
                  ></v-text-field>
                  <v-text-field
                    outline
                    hide-details
                    label="Password"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
                <v-btn
                  @click="login()"
                  color="info"
                  :large="$vuetify.breakpoint.smAndUp"
                >
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex sm12 md6 offset-md3>
            <v-layout align-center justify-space-between>
              <p class="caption my-3">
                <a href="#">Privacy Policy</a>
                |
                <a href="#">Terms of Service</a>
              </p>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>

    <v-snackbar v-model="wrongCredentials" :multi-line="true">
      {{ "Wrong credentials! " }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="wrongCredentials = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import * as AC from "../../store/action-types";

export default {
  name: "Login",

  data() {
    return {
      username: "",
      password: "",
      wrongCredentials: false,
    };
  },
  methods: {
    login() {
      let credentials = {
        username: this.username,
        password: this.password,
      };

      if (credentials) {
        this.$store.dispatch(AC.AUTH_DO_LOGIN, credentials);
      } else {
        this.wrongCredentials = true;
      }
    },
  },
};
</script>
<style></style>
